import React from "react";
import "../../components/StatusList/StatusList.css";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';


const StatusList = ({statusDetailResponse, setOpenProfile, openProfile,GetId,openAddProfile,setOpenAddProfile}) => {
    //console.log(statusDetailResponse);
    function HandleChange(param) {
    
      GetId(param);
    }
  return (
    <div className="container-fluid">
      
      <div className="statusList">
        <table>
          <tr className="statusListHeading">
            <th>S No.</th>
            <th>Status</th>
            
            <th>Action</th>
          </tr>
          {statusDetailResponse !== null ? (
    statusDetailResponse.map((status) => (
        <tr key={status.statusid}>
            <td>{status.statusid}</td>
            <td>{status.statusname}</td>
           
            <td>
                <button style={{ height: "35px", width: "35px", backgroundColor: "#F1F1F1"}} onClick={() => {
                  setOpenProfile(!openProfile);
                  HandleChange(status.statusid); 
                  setOpenAddProfile(false); }}>
                    <EditOutlinedIcon className="icon" />
                </button>
                <button style={{ height: "35px", width: "35px", marginLeft: "5px", backgroundColor: "#F4616F", borderColor: "#FF0000"}} >
                    <DeleteOutlinedIcon className="icon" />
                </button>
            </td>
        </tr>
    ))
) : (
    <p>empty</p>
)}
         
          
        </table>
      </div>
    </div>
  );
};

export default StatusList;
